export enum MapView {
  GB_CENSUS = "GbCensus",
  PT_BOUNDARIES = "PtBoundaries",
  INRIX_VOLUME = "InrixVolume",
  INRIX_AVERAGE_SPEED = "InrixAverageSpeed",
}
